import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
const SingleHeadingText = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: props.parentclassName },
            React.createElement("div", { className: "toc-heading d-flex align-items-center justify-content-between" },
                React.createElement("label", { className: "DMSan_22_500 txt_blackOne1  d-flex" }, props.title)),
            React.createElement("div", { className: "ps-2" }, props.showAdditionalDetails ? (React.createElement("label", { className: "d-flex" }, props.subTitle)) : null),
            props.withClose && props.closeFunction && (React.createElement("div", { className: "toc-close-button" },
                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Close", onClick: () => props.closeFunction() }))))));
};
export default SingleHeadingText;
